<ng-container *transloco="let t; read: 'user'">
<a class="mt-4 shadow-lg shadow-drdpblue-100 rounded-[30px] py-4 px-6 bg-white flex flex-row justify-between cursor-pointer" (click)="emitSelectedMessage(message)">
  <div>
    <span class="text-drdpblue-300 text-lg font-semibold underline mr-4">{{message.studentName}}</span>
    @if (canAccessAllMessages) {
      <span>{{message.recipient}}</span>
      } {{ t('dashboard.portfolio.messages.conversationWith', { name: message.sentFrom }) }}
    </div>
    @if (message.messageStatusId === MessageStatus.New) {
      <div class="bg-drdpblue-300 text-white text-sm rounded-full px-2 py-1">
        {{ t('dashboard.portfolio.messages.newBadge') }}
      </div>
    }
  </a>
</ng-container>
